import React from 'react';
import CarWashDashboard from './CarWashDashboardlocal';

function App() {
  return (
    <div className="min-h-screen bg-gray-100">
      <CarWashDashboard />
    </div>
  );
}

export default App;
